import "../../../../css/modal/MessageSendingModal.css"
import { phoneNumberWithHyphen, moveModal, pressEnter, getByteLength } from "../../../../utils/Utils";
import { useEffect, useState } from "react";
import UserSelector from "../../../../elements/selector/UserSelector";
import proxy from "../../../../utils/Proxy";


let MessageSendingModal = (props) => {
    let [subtitle, setSubtitle] = useState(0)
    let [receivers, setReceivers] = useState([])
    let [receiversByPhoneNumber, setReceiversByPhoneNumber] = useState([])
    let messageSubtitle = ["문자 전송", "레슨 전날 확인 문자 전송", "재등록 일주일 전 문자 전송"]
    let [messageLength, setMessageLength] = useState(0)
    let [defaultMessage, setDefaultMessage] = useState("")

    let clickSubtitle = (index) => {
        setReceivers([])
        setReceiversByPhoneNumber([])
        setSubtitle(index)
    }
    let onClickResult = (user) => {
        for (let currentReceiver of receivers) {
            if (currentReceiver.userid === user.userid)
                return
        }
        setReceivers(prevState => [...prevState, user])
    }

    let onClickAddPhoneNumber = () => {
        let check = /^[0-9]+$/
        let phoneNumber = document.getElementById("message-phone-number-input").value
        if (!check.test(phoneNumber)) {
            window.alert("하이픈(-) 제외 숫자만 입력하세요.")
            return
        }
        if (!receiversByPhoneNumber.includes(phoneNumber))
            setReceiversByPhoneNumber(prevState => [...prevState, phoneNumber])
    }

    let onClickSend = () => {
        if (receivers.length === 0 && receiversByPhoneNumber.length === 0) {
            window.alert("받는 사람은 필수 항목입니다.")
            return
        }
        let message = document.getElementById("message-send-input-data").value
        if (message.length === 0) {
            window.alert("메시지를 입력해주세요.")
            return
        }
        if (messageLength > 2000) {
            window.alert("메시지 길이는 최대 2000byte입니다.")
            return
        }

        // 여기에 메시지 보내는 http 통신 사용

        let body = {}
        switch(subtitle) {
            case 1: // 레슨 전날 확인 문자 전송
                body.smstype = 0
                body.lessonids = []
                body.userids = []
                for (let receiver of receivers) {
                    if (receiver.userid === undefined) {
                        body.lessonids.push(receiver.lessonid)
                    } else {
                        body.userids.push(receiver.userid)
                    }
                }
                break;
            case 2: // 재등록 일주일 전 문자 전송
                body.smstype = 1
                body.userids = receivers.map(receiver => receiver.userid)
                break;
            default: // 기본 문자 전송
                body.smstype = 2
                body.userids = receivers.map(receiver => receiver.userid)
                body.contacts = receiversByPhoneNumber
                body.message = message;
        }

        proxy.post("/adminapi/sms", body).then(() => {
            window.alert("문자 전송이 완료되었습니다.");
            props.onCloseClick();
        }).catch(res => window.alert(res.response.data.message));
    }

    let onChangeMessage = (e) => {
        let message = e.target.value
        setMessageLength(getByteLength(message))
    }

    let cancelMessageSending = () => {
        let dialogResult = window.confirm("문자 작성을 취소하시겠습니까?")
        if (dialogResult)
            props.onCloseClick()
    }

    let messageBox = () => {
        let box
        switch (subtitle) {
            case 1:
            case 2:
                box = (
                    <textarea className="message-send-modal-input"
                        key={"message-send-modal-input" + subtitle}
                        id="message-send-input-data"
                        value={defaultMessage}
                        disabled />
                )
                break;
            default:
                box = (
                    <textarea className="message-send-modal-input"
                        key={"message-send-modal-input" + subtitle}
                        id="message-send-input-data"
                        placeholder="[WEB 발신] 문자를 입력해주세요."
                        onChange={e => onChangeMessage(e)}
                    />
                )
        }
        return box
    }

    useEffect(() => {
        let checkboxs = []
        for (let checkbox of props.checkboxMap) {
            checkboxs.push(checkbox[1])
        }
        setReceivers(checkboxs)
    }, [props.checkboxMap])

    useEffect(() => {
        if (props.filter === 2) setSubtitle(1)
        else if (props.filter === 3) setSubtitle(2)
        else setSubtitle(0)
    }, [props.filter])

    useEffect(() => {
        let text = ""
        if (subtitle === 1) {
            text = (`안녕하세요~
피아노투게더입니다. 

내일 레슨은 %TIME%입니다.
당일 레슨 취소는 보강이 불가하니 예약시간 변경은 오늘 밤 9시까지 해주세요~^^`)
        }
        else if (subtitle === 2) {
            text = (`안녕하세요~ 
피아노투게더입니다. 

%STARTDATE% 부터 시작하신 %NAME%님의 재등록 기간은 %REREGISTER_START%부터 %REREGISTER_END%까지입니다. 

기간 내에 재등록 하실 경우 등록개월수*1만원이 추가할인된 가격으로 연장하실 수 있습니다. (연습실 제외)
    
궁금한 점이 있으시면 아래번호로 연락주세요! 

오늘 하루도 즐거운 일 가득하시기 바랍니다~!`)
        }

        setDefaultMessage(text)
        setMessageLength(getByteLength(text))
    }, [subtitle])

    return (
        <div className="modal-container">
            <div className="modal" id="message-sending-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={(e) => moveModal(e, "message-sending-modal")}>
                        <div className="modal-title-container">
                            <p className="modal-title" id="message-send-modal-title">
                                문자 전송
                            </p>
                            {messageSubtitle.map((text, index) => {
                                return (
                                    <div className="content-subtitle-container" key={"user-management-" + text}>
                                        <div className="content-subtitle-divider"></div>
                                        {index === subtitle ?
                                            <p className="content-subtitle-current" onClick={() => clickSubtitle(index)}>{text}</p> :
                                            <p className="content-subtitle" onClick={() => clickSubtitle(index)}>{text}</p>}
                                    </div>
                                )
                            })}
                        </div>

                        <div className="modal-close-button" onClick={cancelMessageSending}></div>
                    </div>
                    <div className="modal-content">
                        {subtitle === 0 ?
                            <div className="message-send-modal-content-item">
                                <p className="modal-content-text message-send-label">수강생 검색 </p>
                                <UserSelector onClickResult={onClickResult} />
                                <div className="empty-middle-space-remover">
                                </div>
                                <p className="message-send-sub-label">전화번호 추가</p>
                                <div className="message-phone-number-add-container">
                                    <input id="message-phone-number-input"
                                        className="message-contact-add-input"
                                        placeholder="전화번호"
                                        onKeyDown={e => pressEnter(e, onClickAddPhoneNumber)} />
                                    <div className="message-contact-add-button" onClick={onClickAddPhoneNumber} />
                                </div>
                            </div> : null}
                        <div className="message-send-modal-content-item">
                            <p className="modal-content-text message-send-label">받는사람 </p>
                            <div className="message-send-modal-reciever-list-container">
                                {receivers.map((user, index) => {
                                    return (
                                        <div className="message-send-modal-receiver-container"
                                            key={user.userid === undefined ?
                                                "receiver-lessonid-" + user.lessonid :
                                                "receiver-userid-" + user.userid}>
                                            <p className="message-send-modal-receiver">
                                                {user.name + (user.userid === undefined ? "(외부)" : "")}
                                            </p>
                                            <div className="message-send-modal-receiver-delete"
                                                onClick={() =>
                                                    setReceivers(prevState => {
                                                        return [...prevState.slice(0, index), ...prevState.slice(index + 1)]
                                                    })}>
                                            </div>
                                        </div>
                                    )
                                })}
                                {receiversByPhoneNumber.map((contact, index) => {
                                    return (
                                        <div className="message-send-modal-receiver-container" key={"receiver-contact-" + index}>
                                            <p className="message-send-modal-receiver">
                                                {phoneNumberWithHyphen(contact)}
                                            </p>
                                            <div className="message-send-modal-receiver-delete"
                                                onClick={() =>
                                                    setReceiversByPhoneNumber(prevState => {
                                                        return [...prevState.slice(0, index), ...prevState.slice(index + 1)]
                                                    })}>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="message-send-modal-input-container">
                            <p className={"message-send-modal-length-info" + (messageLength > 2000 ? " message-send-modal-length-over" : "")}>
                                최대: {messageLength}/2000 byte
                            </p>
                            {messageBox()}

                        </div>


                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={onClickSend}>
                                <p>전송</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MessageSendingModal;
